export const agentSpecResources = {
  fr: {
    eyebrow: "Agent Studio",
    title: "Agent Spec",
    calistoNavigation: "Calisto",
    description:
      "Contrôlez le desired state de cet Agent avec un plan immuable et la gouvernance adaptée à l’environnement.",
    selectContextTitle: "Sélection requise",
    selectOrganization:
      "Sélectionnez une organisation pour charger l’Agent Spec.",
    selectAgent: "Sélectionnez un Agent pour charger son Agent Spec.",
    loading: "Chargement de l’Agent Spec…",
    refresh: "Actualiser",
    retry: "Réessayer",
    errorTitle: "Agent Spec indisponible",
    missingTitle: "Aucune Agent Spec",
    missingDescription:
      "Initialisez un draft vide. Cette action ne crée aucune ressource runtime.",
    initAction: "Initialiser Agent Spec",
    initPending: "Initialisation…",
    overviewTitle: "État déclaratif",
    overviewDescription:
      "Révision, contrat et provenance de la spécification chargée.",
    status: "Statut",
    resourceVersion: "Version de ressource",
    specHash: "Spec hash",
    contract: "Contrat",
    lastUpdate: "Dernière actualisation",
    warningCount: "{{count}} avertissement(s)",
    currentPlanTitle: "Plan courant",
    currentPlanDescription:
      "Le plan à traiter maintenant : progression, prochaine action, puis historique des autres plans.",
    currentPlanEmpty:
      "Aucun plan sélectionné. Préparez-en un depuis le thread Studio, ou ouvrez un plan dans l’historique.",
    otherPlansTitle: "Autres plans",
    otherPlansDescription:
      "Historique des plans préparés par MauriceCLI, MCP ou l’OS. Un clic remplace le plan courant.",
    otherPlansEmpty: "Aucun autre plan — le plan courant est le seul disponible.",
    persistedPlansTitle: "Plans persistés à examiner",
    persistedPlansDescription:
      "Plans préparés par MauriceCLI, MCP ou l’OS. Chargez le détail exact avant toute approbation humaine.",
    persistedPlansLoading: "Chargement des plans persistés…",
    persistedPlansError: "Impossible de charger les plans persistés.",
    persistedPlansEmpty: "Aucun plan préparé, approuvé ou appliqué récemment.",
    refreshPlans: "Actualiser les plans",
    planStatusPrepared: "À approuver",
    planStatusApproved: "Approuvé",
    planStatusApplying: "Application en cours",
    planStatusApplied: "Appliqué",
    planStatusFailed: "Échec",
    planStatusExpired: "Expiré",
    planStatusSuperseded: "Remplacé",
    gitCommit: "Commit Git",
    expiresAt: "Expiration",
    exactArtifactTitle: "Artefact exécutable exact",
    exactArtifactDescription:
      "Cet artefact persistant est celui que l’approbation engage et qu’apply exécutera sans recompilation.",
    railTitle: "Plan courant",
    railDescription:
      "En development : préparez puis mettez en œuvre depuis le thread Studio. Staging/production exigent une approbation humaine.",
    railHintPull: "Chargez d’abord le desired state (Pull).",
    railHintPrepare:
      "Étape suivante : Préparer le plan depuis le thread Studio courant (check + plan ; en development l’application peut enchaîner automatiquement).",
    railHintApprove:
      "Étape suivante : Approuver le plan (approbation humaine requise sur cet environnement).",
    railHintCloseout:
      "Étape suivante : Mettre en œuvre (apply → verify, avec réparation auto si besoin).",
    railHintApplyPersisted:
      "Étape suivante : Appliquer ce plan persisté. « Mettre en œuvre » ne s’applique qu’au plan scellé du thread Studio.",
    railHintSuperseded:
      "Ce plan a été remplacé ou a expiré. Un plan plus récent a été sélectionné, ou préparez-en un nouveau depuis le thread Studio.",
    railHintVerify: "Étape suivante : Vérifier le résultat runtime.",
    railHintIdle: "Aucune action urgente — ce plan est déjà traité ou hors fenêtre.",
    railHintSelectOrCalisto:
      "Ouvrez Calisto pour préparer un plan depuis un thread Studio, ou choisissez un plan dans l’historique.",
    closeoutRequiresSealedRevision:
      "Mettre en œuvre exige un plan préparé depuis le thread Studio (révision scellée). Pour ce plan, utilisez « Appliquer le plan ».",
    closeoutRequiresPlan:
      "Aucun plan n’est lié à la révision Studio. Préparez d’abord le plan depuis le thread.",
    stepPull: "Pull",
    stepPullDescription: "Desired state V2 chargé depuis la source canonique.",
    stepCheck: "Check",
    stepCheckDescription: "Contrats, capacités et références validés.",
    stepPlan: "Plan",
    stepPlanDescription:
      "Diff et préconditions compilés dans un artefact immuable.",
    stepApproval: "Approbation",
    stepApprovalDescription:
      "Autorisation automatique par policy ou approbation humaine selon l’environnement.",
    stepApply: "Apply",
    stepApplyDescription: "Application idempotente de l’artefact approuvé.",
    stepVerification: "Vérification",
    stepVerificationDescription:
      "Desired state, runtime et provenance comparés.",
    stateReady: "Prêt",
    stateWaiting: "En attente",
    stateRunning: "En cours",
    stateComplete: "Terminé",
    stateFailed: "Échec",
    checkAction: "Vérifier la spec",
    checkPending: "Vérification…",
    planAction: "Préparer le plan",
    planPending: "Préparation…",
    approvalAction: "Approuver le plan",
    applyAction: "Appliquer le plan",
    applyPending: "Application…",
    verifyAction: "Vérifier le résultat",
    verifyPending: "Vérification runtime…",
    closeoutAction: "Mettre en œuvre",
    closeoutPending: "Mise en œuvre…",
    closeoutDescription:
      "Applique le plan approuvé, vérifie le runtime, puis répare automatiquement en cas d’échec.",
    studioPrepareAutoAction: "Préparation automatique…",
    studioPrepareAutoPending: "Préparation et mise en œuvre…",
    studioPrepareAutoStarted: "Plan préparé — closeout en cours ou terminé.",
    studioCloseoutStayInChat:
      "Draft appliqué. Pour continuer à modifier, commencez une nouvelle révision puis décrivez le changement.",
    studioNewRevisionReady:
      "Nouveau draft prêt — décrivez la prochaine modification à Calisto.",
    studioNewRevisionHint:
      "Ouvre un nouveau draft éditable dans ce fil. Décrivez ensuite le changement dans le champ ci-dessous.",
    studioContinueWithCalisto: "Continuer avec Calisto",
    studioViewAppliedPlan: "Voir le plan appliqué",
    closeoutStatusIdle: "Aucun closeout en cours",
    closeoutStatusAwaitingApproval: "En attente d’approbation après réparation",
    closeoutStatusClosingOut: "Closeout en cours (apply → verify)",
    closeoutStatusSucceeded: "Closeout réussi",
    closeoutStatusRepairing: "Réparation Calisto en cours",
    closeoutStatusBlocked: "Closeout bloqué",
    closeoutRepairCycles: "Cycles de réparation : {{current}}/{{max}}",
    closeoutEvidence: "Evidence : {{detail}}",
    studioJobStatusQueued: "StudioJob en file",
    studioJobStatusRunning: "StudioJob en cours",
    studioJobStatusSucceeded: "StudioJob réussi",
    studioJobStatusBlocked: "StudioJob bloqué",
    studioJobStatusCancelled: "StudioJob annulé",
    studioJobGoalLabel: "Goal : {{title}}",
    checkRequired: "Un check valide est requis avant de préparer le plan.",
    approvalRequired:
      "La policy de cet environnement exige une approbation humaine avant apply.",
    policyAuthorized: "Autorisé automatiquement par la policy serveur.",
    approvalDialogTitle: "Approbation humaine",
    approvalDialogDescription:
      "Confirmez le diff, le risque, l’environnement, le commit et le hash. Le serveur lie votre identité au plan exact.",
    approvalCommentLabel: "Commentaire facultatif",
    approvalCommentPlaceholder: "Contexte ou remarque pour l’audit…",
    approvalTextLabel: "Texte d’approbation",
    approvalTextPlaceholder: "J’approuve le plan {{hash}}",
    approvalHashHint: "Hash exact : {{hash}}",
    approvalCancel: "Annuler",
    approvalConfirm: "Enregistrer l’approbation",
    approvalPending: "Enregistrement…",
    approvalTextInvalid: "Le texte doit contenir le hash exact du plan.",
    failureTitle: "Échec d’application",
    failureRecovery:
      "Créez un nouveau plan avec maurice spec deploy après avoir corrigé la cause.",
    currentRuntimePlan: "État runtime courant issu du plan {{planId}}.",
    planTitle: "Plan immuable",
    planDescription: "Plan {{id}} — expiration {{expiresAt}}",
    noPlan: "Préparez un plan pour afficher le diff, le risque et les tests.",
    diffTitle: "Diff sémantique",
    diffEmpty: "Aucun changement sémantique.",
    diffAdded: "{{count}} ajout(s)",
    diffModified: "{{count}} modification(s)",
    diffRemoved: "{{count}} suppression(s)",
    riskTitle: "Risque",
    riskLow: "Faible",
    riskMedium: "Moyen",
    riskHigh: "Élevé",
    riskCritical: "Critique",
    blastRadiusTitle: "Blast radius",
    blastRadiusEmpty: "Aucun composant runtime touché.",
    testsTitle: "Politique de tests",
    testsMode: "Mode",
    testsEnvironment: "Environnement",
    testsBlocking: "Bloquant",
    testsPlan: "Test plan",
    present: "Présent",
    absent: "Absent",
    yes: "Oui",
    no: "Non",
    resourcesTitle: "Ownership des ressources",
    resourcesDescription:
      "Les Workflows et MiniApps inclus dans cette Agent Spec sont managed et ne sont jamais modifiables directement.",
    workflowsTitle: "Workflows",
    miniappsTitle: "MiniApps",
    plansNavigation: "Plans",
    executionsNavigation: "Exécutions",
    agentView: "Vue Agent",
    agentOverview: "Vue globale",
    workflowLabel: "Workflow",
    miniappLabel: "MiniApp",
    resourceSummary: "Résumé",
    resourceGraph: "Graphe",
    resourceApiCall: "Appel API",
    resourcePreview: "Preview",
    synchronousWorkflowCall: "Appel synchrone",
    synchronousWorkflowCallDescription:
      "Attend la fin du Workflow et retourne directement son résultat.",
    asynchronousWorkflowCall: "Appel asynchrone",
    asynchronousWorkflowCallDescription:
      "Démarre le Workflow, retourne immédiatement un identifiant d’exécution, puis permet de suivre son état.",
    pollWorkflowExecution: "Suivre l’exécution",
    graphSelectNode: "Sélectionnez un nœud pour afficher sa configuration.",
    graphNodeDetails: "Détails du nœud",
    graphCloseNodeDetails: "Fermer les détails du nœud",
    graphNodeId: "Identifiant",
    graphNodeType: "Type",
    graphNodeConfiguration: "Configuration",
    selectResource: "Sélectionnez une ressource.",
    noResourceDescription: "Aucune description.",
    runtimeResourcesErrorTitle: "Ressources runtime indisponibles",
    runtimeResourcesErrorDescription:
      "La liste affichée peut être incomplète. Les Workflows et MiniApps runtime n’ont pas pu être chargés.",
    retryRuntimeResources: "Recharger les ressources runtime",
    workflowActions: "Actions",
    miniappEvents: "Événements",
    resourceOwnershipAndProvenance: "Ownership et provenance",
    managementMode: "Mode de gestion",
    ownerRevision: "Révision propriétaire",
    ownerAgentSpec: "Agent Spec propriétaire",
    contentHash: "Hash du contenu",
    inputSchema: "Schéma d’entrée",
    outputSchema: "Schéma de sortie",
    workflowForms: "Formulaires",
    miniappRenderer: "Renderer",
    miniappComponent: "Composant",
    stateSchema: "Schéma d’état",
    initialState: "État initial",
    eventMappings: "Mappings d’événements",
    copyApiRequest: "Copier la requête API",
    apiRequestCopied: "Requête API copiée.",
    apiAvailableAfterApply:
      "Cet appel sera disponible après l’application du draft.",
    createMiniappSession: "Créer une session MiniApp",
    miniappEventLabel: "Événement MiniApp",
    manageApiKeys: "Gérer les clés API",
    resourceState: {
      deployed: "Déployé",
      modified: "Modifié",
      new: "Nouveau",
      deleted: "Supprimé",
      outsideSpec: "Hors Agent Spec",
    },
    previewSandboxDescription:
      "Cette preview temporaire exécute le draft sur l’Agent courant (sandbox, development ou integration_test) sans créer de ressource runtime managed.",
    previewRuntimeDescription:
      "Cette preview lance une session runtime de la MiniApp déployée sur cet Agent, sans modifier le desired state.",
    previewRequiresSandboxTitle: "Preview indisponible sur cet Agent",
    previewRequiresSandboxBody:
      "L’Agent courant est en mode « {{profile}} ». La preview de draft est réservée aux Agents sandbox, development et integration_test. En staging/production, utilisez le cycle d’approbation, ou basculez vers un Agent de développement.",
    previewRequiresSandboxError:
      "La preview de draft n’est pas disponible sur cet Agent (mode « {{profile}} »). Elle est autorisée en sandbox, development et integration_test.",
    previewUnknownProfile: "inconnu",
    invalidPlanId:
      "Identifiant de plan invalide dans l’URL — paramètre ignoré. Sélectionnez un plan dans la liste.",
    previewCreateSandboxAgent: "Créer un Agent sandbox et y tester ce draft",
    previewSwitchAgentHint:
      "Ou ouvrez le sélecteur d’Agent en haut à gauche pour basculer vers un Agent sandbox existant.",
    previewCreateSandboxTitle: "Créer un Agent sandbox",
    previewCreateSandboxDescription:
      "Un nouvel Agent classé sandbox sera créé. Vous pourrez y initialiser un draft et lancer des previews sans toucher cet Agent.",
    previewCreateSandboxSeedDialogTitle:
      "Créer un Agent sandbox et y tester ce draft",
    previewCreateSandboxSeedDescription:
      "Confirmez pour créer l’Agent sandbox, y copier ce draft, ouvrir le chat et relancer la preview.",
    previewCreateSandboxSeedConfirm: "Confirmer",
    previewCreateSandboxSeedTitle: "Draft sandbox — {{name}}",
    previewCreateSandboxSeedSuccess:
      "Agent sandbox {{name}} prêt. Draft copié — preview en cours.",
    previewCreateSandboxContinueStarted: "Preview draft relancée sur le sandbox.",
    previewCreateSandboxContinueFailed:
      "Le draft a été copié, mais la preview n’a pas pu démarrer automatiquement.",
    previewCreateSandboxNameLabel: "Nom de l’Agent",
    previewCreateSandboxNamePlaceholder: "Assistant sandbox",
    previewCreateSandboxConfirm: "Créer et ouvrir",
    previewCreateSandboxSubmitting: "Création…",
    previewCreateSandboxSuccess: "Agent sandbox {{name}} créé.",
    previewCreateSandboxFailed: "Impossible de créer l’Agent sandbox.",
    previewCreateSandboxConflict:
      "Un Agent avec ce nom existe déjà. Choisissez un autre nom.",
    previewCreateSandboxNameRequired: "Le nom de l’Agent est requis.",
    previewConfirmTitle: "Exécuter cette preview ?",
    previewConfirmDescription:
      "Cette action exécute le draft dans une session sandbox temporaire sans modifier le runtime appliqué.",
    previewConfirmAction: "Exécuter la preview",
    runWorkflowPreview: "Exécuter la preview Workflow",
    previewExecutionStarted: "Exécution de preview démarrée",
    startMiniappPreview: "Ouvrir la preview MiniApp",
    studioChatPreviewTitle: "Preview {{kind}} — {{id}}",
    studioChatPreviewClose: "Fermer la preview",
    studioChatPreviewStarting: "Démarrage de la preview…",
    studioChatPreviewMissingDocument:
      "Document introuvable dans le draft courant.",
    studioChatPreviewOpenUIFallback:
      "Rendu OpenUI incomplet — bascule sur le rendu natif.",
    previewStateVersion: "État version {{version}}",
    executionsTitle: "Exécutions et observabilité",
    executionsDescription:
      "États, logs, traces, résultats, durées, usages et coûts des Workflows.",
    executionsEmpty: "Aucune exécution pour cet Agent.",
    refreshExecutions: "Actualiser les exécutions",
    executionDetails: "Détails de l’exécution",
    selectExecution: "Sélectionnez une exécution à examiner.",
    duration: "Durée",
    traceId: "Trace ID",
    llmCalls: "Appels LLM",
    tokens: "Tokens",
    estimatedCost: "Coût estimé",
    executionLogs: "Logs",
    executionLogsEmpty: "Aucun log.",
    executionResult: "Résultat",
    executionLoadError: "Impossible de charger cette exécution.",
    agentConfiguration: "Configuration de l’Agent",
    instructions: "Instructions",
    capabilities: "Capabilities",
    dependencies: "Dependencies",
    parameters: "Paramètres",
    secretReferences: "Références de secrets",
    policyReferences: "Policies",
    governance: "Gouvernance",
    exportBundle: "Exporter le bundle",
    noWorkflows: "Aucun Workflow déclaré.",
    noMiniapps: "Aucune MiniApp déclarée.",
    managed: "Managed",
    unmanaged: "Sandbox unmanaged",
    managedDescription:
      "Lecture seule — toute modification passe par un nouveau plan Agent Spec.",
    unmanagedDescription:
      "Mutation directe autorisée uniquement dans le sandbox explicitement unmanaged.",
    owner: "Owner",
    file: "Fichier",
    version: "Version",
    diagnosticsTitle: "Diagnostics",
    noDiagnostics: "Aucun diagnostic.",
    checkValid: "Agent Spec valide",
    checkInvalid: "Agent Spec invalide",
    verificationTitle: "Vérification finale",
    verificationVerified: "État vérifié",
    verificationDrifted: "Drift détecté",
    desiredStateMatch: "Desired state conforme",
    planApplied: "Plan appliqué",
    approvalApplied: "Approbation consommée",
    provenance: "Provenance",
    studioPanelTitle: "Calisto",
    studioPanelDescription:
      "Ce fil partagé modifie uniquement le draft Agent Spec V2.",
    studioNoThread: "Aucun fil pour cet Agent.",
    studioNoThreadYet: "Aucun fil pour le moment.",
    studioThreadsTitle: "Fils Studio",
    studioThreadsLoading: "Chargement des fils…",
    studioSelectThreadHint:
      "Sélectionnez un fil dans la sidebar ou créez-en un nouveau.",
    studioCreateThread: "Nouveau fil",
    studioCreateThreadSuccess: "Nouveau fil créé",
    studioCreatingThread: "Création…",
    studioFromGoalAction: "Depuis un goal",
    studioFromGoalTitle: "Démarrer depuis un goal",
    studioFromGoalDescription:
      "Crée un fil Studio avec un StudioJob closed_loop lié à ce goal.",
    studioFromGoalTitleLabel: "Titre du goal",
    studioFromGoalTitlePlaceholder: "Ex. Ajouter un workflow de veille",
    studioFromGoalDescriptionLabel: "Description (optionnel)",
    studioFromGoalDescriptionPlaceholder:
      "Critères de succès ou contexte utile pour Calisto…",
    studioFromGoalCancel: "Annuler",
    studioFromGoalConfirm: "Créer le StudioJob",
    studioFromGoalPending: "Création…",
    studioFromGoalSuccess: "StudioJob créé depuis le goal",
    studioThreadLabel: "Fil partagé",
    studioEmptyMessages: "Décrivez les changements à apporter à cet Agent.",
    studioMessagePlaceholder:
      "Décrivez le comportement, les Workflows ou les MiniApps à modifier…",
    studioSend: "Envoyer",
    studioSending: "Le modèle prépare une proposition…",
    studioActivityTool: "Calisto utilise les outils Agent Spec…",
    studioRuntimeToolResult: "Résultat de l’outil {{name}}",
    studioWorkflowExecution: "Exécution du Workflow {{name}}",
    studioShowStructuredResult: "Afficher le résultat structuré",
    studioViewExecution: "Voir l’exécution, les logs et la trace",
    studioActivityCheck: "Calisto vérifie le draft…",
    studioResponseTimeout:
      "La réponse Studio prend trop de temps. Le fil a été rechargé ; vous pouvez réessayer.",
    studioAttach: "Joindre un document",
    studioAttachmentReady: "{{name}} prêt",
    studioAttachmentRejected: "{{name}} refusé",
    studioDraftValid: "Draft valide",
    studioDraftInvalid: "{{count}} diagnostic(s)",
    studioPreparePlan: "Préparer le plan",
    studioPreparingPlan: "Scellement…",
    studioPlanPrepared: "Révision scellée et plan sélectionné.",
    studioNewRevision: "Commencer une nouvelle révision",
    studioStreamingConnected: "Synchronisé",
    studioStreamingDisconnected: "Reconnexion…",
    studioSharedHint: "Visible par tous les éditeurs de cet Agent.",
    studioNoAgent: "Sélectionnez un Agent pour ouvrir Studio.",
    studioWritePermissionRequired:
      "La permission write:recipes est requise pour utiliser Studio.",
    studioError: "Studio est momentanément indisponible.",
    studioRevisionConflict:
      "Le draft a changé pendant ce tour. Le fil a été rechargé et votre message a été restauré ; vous pouvez le renvoyer.",
    studioNoActiveDraft:
      "Cette révision n’est plus un draft éditable. Cliquez « Commencer une nouvelle révision », puis décrivez le changement dans le fil.",
    studioRevisionStatus: {
      none: "Aucune révision",
      draft: "Draft",
      sealed: "Révision scellée",
      planned: "Révision planifiée",
      terminal: "Révision terminée",
    },
    studioAction: {
      prepare_plan: "Préparer le plan",
      approve: "Examiner l’approbation",
      apply: "Examiner l’application",
      verify: "Examiner la vérification",
      preview: "Ouvrir la preview",
      test: "Tester la ressource",
      create_sandbox_agent: "Créer un Agent sandbox et y tester ce draft",
      new_revision: "Commencer une nouvelle révision",
    },
  },
  en: {
    eyebrow: "Agent Studio",
    title: "Agent Spec",
    calistoNavigation: "Calisto",
    description:
      "Control this Agent desired state with an immutable plan and environment-appropriate governance.",
    selectContextTitle: "Selection required",
    selectOrganization: "Select an organization to load the Agent Spec.",
    selectAgent: "Select an Agent to load its Agent Spec.",
    loading: "Loading Agent Spec…",
    refresh: "Refresh",
    retry: "Try again",
    errorTitle: "Agent Spec unavailable",
    missingTitle: "No Agent Spec",
    missingDescription:
      "Initialize an empty draft. This action creates no runtime resource.",
    initAction: "Initialize Agent Spec",
    initPending: "Initializing…",
    overviewTitle: "Declarative state",
    overviewDescription:
      "Revision, contract and provenance of the loaded specification.",
    status: "Status",
    specHash: "Spec hash",
    contract: "Contract",
    lastUpdate: "Last refresh",
    warningCount: "{{count}} warning(s)",
    currentPlanTitle: "Current plan",
    currentPlanDescription:
      "The plan to handle now: progress, next action, then history of other plans.",
    currentPlanEmpty:
      "No plan selected. Prepare one from the Studio thread, or open a plan from history.",
    otherPlansTitle: "Other plans",
    otherPlansDescription:
      "History of plans prepared by MauriceCLI, MCP, or the OS. Click one to make it the current plan.",
    otherPlansEmpty: "No other plans — the current plan is the only one available.",
    persistedPlansTitle: "Persisted plans to review",
    persistedPlansDescription:
      "Plans prepared by MauriceCLI, MCP, or the OS. Load the exact detail before any human approval.",
    persistedPlansLoading: "Loading persisted plans…",
    persistedPlansError: "Could not load persisted plans.",
    persistedPlansEmpty: "No recently prepared, approved, or applied plan.",
    refreshPlans: "Refresh plans",
    planStatusPrepared: "Needs approval",
    planStatusApproved: "Approved",
    planStatusApplying: "Applying",
    planStatusApplied: "Applied",
    planStatusFailed: "Failed",
    planStatusExpired: "Expired",
    planStatusSuperseded: "Superseded",
    gitCommit: "Git commit",
    expiresAt: "Expiration",
    exactArtifactTitle: "Exact executable artifact",
    exactArtifactDescription:
      "This persisted artifact is what the approval authorizes and what apply will execute without recompiling.",
    railTitle: "Current plan",
    railDescription:
      "In development: prepare then ship from the Studio thread. Staging/production require human approval.",
    railHintPull: "Load the desired state first (Pull).",
    railHintPrepare:
      "Next: Prepare the plan from the current Studio thread (check + plan; in development apply may continue automatically).",
    railHintApprove:
      "Next: Approve the plan (human approval required in this environment).",
    railHintCloseout:
      "Next: Ship changes (apply → verify, with auto-repair if needed).",
    railHintApplyPersisted:
      "Next: Apply this persisted plan. “Ship changes” only works for the sealed Studio thread plan.",
    railHintSuperseded:
      "This plan was superseded or expired. A newer plan was selected, or prepare a new one from the Studio thread.",
    railHintVerify: "Next: Verify the runtime result.",
    railHintIdle: "No urgent action — this plan is already handled or out of window.",
    railHintSelectOrCalisto:
      "Open Calisto to prepare a plan from a Studio thread, or choose a plan from history.",
    closeoutRequiresSealedRevision:
      "Shipping requires a plan prepared from the Studio thread (sealed revision). For this plan, use “Apply plan”.",
    closeoutRequiresPlan:
      "No plan is linked to the Studio revision. Prepare the plan from the thread first.",
    stepPull: "Pull",
    stepPullDescription: "V2 desired state loaded from the canonical source.",
    stepCheck: "Check",
    stepCheckDescription: "Contracts, capabilities and references validated.",
    stepPlan: "Plan",
    stepPlanDescription:
      "Diff and preconditions compiled into an immutable artifact.",
    stepApproval: "Approval",
    stepApprovalDescription:
      "Automatic policy authorization or human approval, depending on the environment.",
    stepApply: "Apply",
    stepApplyDescription: "Idempotent application of the approved artifact.",
    stepVerification: "Verification",
    stepVerificationDescription:
      "Desired state, runtime and provenance compared.",
    stateReady: "Ready",
    stateWaiting: "Waiting",
    stateRunning: "Running",
    stateComplete: "Complete",
    stateFailed: "Failed",
    checkAction: "Check spec",
    checkPending: "Checking…",
    planAction: "Prepare plan",
    planPending: "Preparing…",
    approvalAction: "Approve plan",
    applyAction: "Apply plan",
    applyPending: "Applying…",
    verifyAction: "Verify result",
    verifyPending: "Verifying runtime…",
    closeoutAction: "Ship changes",
    closeoutPending: "Shipping…",
    closeoutDescription:
      "Applies the approved plan, verifies runtime, then auto-repairs on failure.",
    studioPrepareAutoAction: "Auto-preparing…",
    studioPrepareAutoPending: "Preparing and shipping…",
    studioPrepareAutoStarted: "Plan prepared — closeout running or finished.",
    studioCloseoutStayInChat:
      "Draft applied. To keep editing, start a new revision then describe the change.",
    studioNewRevisionReady:
      "New draft ready — describe the next change to Calisto.",
    studioNewRevisionHint:
      "Opens a new editable draft in this thread. Then describe the change in the field below.",
    studioContinueWithCalisto: "Continue with Calisto",
    studioViewAppliedPlan: "View applied plan",
    closeoutStatusIdle: "No closeout in progress",
    closeoutStatusAwaitingApproval: "Waiting for approval after repair",
    closeoutStatusClosingOut: "Closeout in progress (apply → verify)",
    closeoutStatusSucceeded: "Closeout succeeded",
    closeoutStatusRepairing: "Calisto repair in progress",
    closeoutStatusBlocked: "Closeout blocked",
    closeoutRepairCycles: "Repair cycles: {{current}}/{{max}}",
    closeoutEvidence: "Evidence: {{detail}}",
    studioJobStatusQueued: "StudioJob queued",
    studioJobStatusRunning: "StudioJob running",
    studioJobStatusSucceeded: "StudioJob succeeded",
    studioJobStatusBlocked: "StudioJob blocked",
    studioJobStatusCancelled: "StudioJob cancelled",
    studioJobGoalLabel: "Goal: {{title}}",
    checkRequired: "A valid check is required before preparing the plan.",
    approvalRequired:
      "This environment policy requires human approval before apply.",
    policyAuthorized: "Automatically authorized by server policy.",
    approvalDialogTitle: "Human approval",
    approvalDialogDescription:
      "Confirm the diff, risk, environment, commit, and hash. The server binds your identity to the exact plan.",
    approvalCommentLabel: "Optional comment",
    approvalCommentPlaceholder: "Audit context or note…",
    approvalTextLabel: "Approval text",
    approvalTextPlaceholder: "I approve plan {{hash}}",
    approvalHashHint: "Exact hash: {{hash}}",
    approvalCancel: "Cancel",
    approvalConfirm: "Record approval",
    approvalPending: "Recording…",
    approvalTextInvalid: "The text must contain the exact plan hash.",
    failureTitle: "Apply failed",
    failureRecovery:
      "Fix the cause, then create a new plan with maurice spec deploy.",
    currentRuntimePlan: "Current runtime state comes from plan {{planId}}.",
    planTitle: "Immutable plan",
    planDescription: "Plan {{id}} — expires {{expiresAt}}",
    noPlan: "Prepare a plan to display its diff, risk and tests.",
    diffTitle: "Semantic diff",
    diffEmpty: "No semantic change.",
    diffAdded: "{{count}} addition(s)",
    diffModified: "{{count}} change(s)",
    diffRemoved: "{{count}} removal(s)",
    riskTitle: "Risk",
    riskLow: "Low",
    riskMedium: "Medium",
    riskHigh: "High",
    riskCritical: "Critical",
    blastRadiusTitle: "Blast radius",
    blastRadiusEmpty: "No runtime component touched.",
    testsTitle: "Test policy",
    testsMode: "Mode",
    testsEnvironment: "Environment",
    testsBlocking: "Blocking",
    testsPlan: "Test plan",
    present: "Present",
    absent: "Absent",
    yes: "Yes",
    no: "No",
    resourcesTitle: "Resource ownership",
    resourcesDescription:
      "Workflows and MiniApps included in this Agent Spec are managed and can never be changed directly.",
    workflowsTitle: "Workflows",
    miniappsTitle: "MiniApps",
    plansNavigation: "Plans",
    executionsNavigation: "Executions",
    agentView: "Agent view",
    agentOverview: "Overview",
    workflowLabel: "Workflow",
    miniappLabel: "MiniApp",
    resourceSummary: "Summary",
    resourceGraph: "Graph",
    resourceApiCall: "API call",
    resourcePreview: "Preview",
    synchronousWorkflowCall: "Synchronous call",
    synchronousWorkflowCallDescription:
      "Waits for the Workflow to finish and returns its result directly.",
    asynchronousWorkflowCall: "Asynchronous call",
    asynchronousWorkflowCallDescription:
      "Starts the Workflow, immediately returns an execution ID, then lets the caller poll its status.",
    pollWorkflowExecution: "Poll the execution",
    graphSelectNode: "Select a node to inspect its configuration.",
    graphNodeDetails: "Node details",
    graphCloseNodeDetails: "Close node details",
    graphNodeId: "Identifier",
    graphNodeType: "Type",
    graphNodeConfiguration: "Configuration",
    selectResource: "Select a resource.",
    noResourceDescription: "No description.",
    runtimeResourcesErrorTitle: "Runtime resources unavailable",
    runtimeResourcesErrorDescription:
      "The displayed list may be incomplete. Runtime Workflows and MiniApps could not be loaded.",
    retryRuntimeResources: "Reload runtime resources",
    workflowActions: "Actions",
    miniappEvents: "Events",
    resourceOwnershipAndProvenance: "Ownership and provenance",
    managementMode: "Management mode",
    ownerRevision: "Owner revision",
    resourceVersion: "Resource version",
    ownerAgentSpec: "Owner Agent Spec",
    contentHash: "Content hash",
    inputSchema: "Input schema",
    outputSchema: "Output schema",
    workflowForms: "Forms",
    miniappRenderer: "Renderer",
    miniappComponent: "Component",
    stateSchema: "State schema",
    initialState: "Initial state",
    eventMappings: "Event mappings",
    copyApiRequest: "Copy API request",
    apiRequestCopied: "API request copied.",
    apiAvailableAfterApply:
      "This call will be available after the draft is applied.",
    createMiniappSession: "Create a MiniApp session",
    miniappEventLabel: "MiniApp event",
    manageApiKeys: "Manage API keys",
    resourceState: {
      deployed: "Deployed",
      modified: "Modified",
      new: "New",
      deleted: "Deleted",
      outsideSpec: "Outside Agent Spec",
    },
    previewSandboxDescription:
      "This temporary preview runs the draft on the current Agent (sandbox, development, or integration_test) without creating managed runtime resources.",
    previewRuntimeDescription:
      "This preview starts a runtime session of the deployed MiniApp on this Agent without changing the desired state.",
    previewRequiresSandboxTitle: "Preview unavailable on this Agent",
    previewRequiresSandboxBody:
      "The current Agent is in “{{profile}}” mode. Draft preview is limited to sandbox, development, and integration_test Agents. On staging/production, use the approval cycle, or switch to a development Agent.",
    previewRequiresSandboxError:
      "Draft preview is not available on this Agent (“{{profile}}” mode). It is allowed on sandbox, development, and integration_test.",
    previewUnknownProfile: "unknown",
    invalidPlanId:
      "Invalid plan id in the URL — parameter ignored. Select a plan from the list.",
    previewCreateSandboxAgent: "Create a sandbox Agent and test this draft there",
    previewSwitchAgentHint:
      "Or open the Agent switcher at the top left to switch to an existing sandbox Agent.",
    previewCreateSandboxTitle: "Create a sandbox Agent",
    previewCreateSandboxDescription:
      "A new Agent classified as sandbox will be created. You can initialize a draft there and run previews without touching this Agent.",
    previewCreateSandboxSeedDialogTitle:
      "Create a sandbox Agent and test this draft there",
    previewCreateSandboxSeedDescription:
      "Confirm to create the sandbox Agent, copy this draft, open chat, and continue the preview.",
    previewCreateSandboxSeedConfirm: "Confirm",
    previewCreateSandboxSeedTitle: "Sandbox draft — {{name}}",
    previewCreateSandboxSeedSuccess:
      "Sandbox Agent {{name}} ready. Draft copied — preview starting.",
    previewCreateSandboxContinueStarted: "Draft preview resumed on the sandbox.",
    previewCreateSandboxContinueFailed:
      "The draft was copied, but the preview could not start automatically.",
    previewCreateSandboxNameLabel: "Agent name",
    previewCreateSandboxNamePlaceholder: "Sandbox assistant",
    previewCreateSandboxConfirm: "Create and open",
    previewCreateSandboxSubmitting: "Creating…",
    previewCreateSandboxSuccess: "Sandbox Agent {{name}} created.",
    previewCreateSandboxFailed: "Unable to create the sandbox Agent.",
    previewCreateSandboxConflict:
      "An Agent with this name already exists. Choose a different name.",
    previewCreateSandboxNameRequired: "Agent name is required.",
    previewConfirmTitle: "Run this preview?",
    previewConfirmDescription:
      "This runs the draft in a temporary sandbox session without changing the applied runtime.",
    previewConfirmAction: "Run preview",
    runWorkflowPreview: "Run Workflow preview",
    previewExecutionStarted: "Preview execution started",
    startMiniappPreview: "Open MiniApp preview",
    studioChatPreviewTitle: "Preview {{kind}} — {{id}}",
    studioChatPreviewClose: "Close preview",
    studioChatPreviewStarting: "Starting preview…",
    studioChatPreviewMissingDocument:
      "Document not found in the current draft.",
    studioChatPreviewOpenUIFallback:
      "OpenUI rendering incomplete — falling back to native rendering.",
    previewStateVersion: "State version {{version}}",
    executionsTitle: "Executions and observability",
    executionsDescription:
      "Workflow states, logs, traces, results, durations, usage, and costs.",
    executionsEmpty: "No execution for this Agent.",
    refreshExecutions: "Refresh executions",
    executionDetails: "Execution details",
    selectExecution: "Select an execution to inspect.",
    duration: "Duration",
    traceId: "Trace ID",
    llmCalls: "LLM calls",
    tokens: "Tokens",
    estimatedCost: "Estimated cost",
    executionLogs: "Logs",
    executionLogsEmpty: "No log.",
    executionResult: "Result",
    executionLoadError: "Unable to load this execution.",
    agentConfiguration: "Agent configuration",
    instructions: "Instructions",
    capabilities: "Capabilities",
    dependencies: "Dependencies",
    parameters: "Parameters",
    secretReferences: "Secret references",
    policyReferences: "Policies",
    governance: "Governance",
    exportBundle: "Export bundle",
    noWorkflows: "No Workflow declared.",
    noMiniapps: "No MiniApp declared.",
    managed: "Managed",
    unmanaged: "Unmanaged sandbox",
    managedDescription:
      "Read-only — every change goes through a new Agent Spec plan.",
    unmanagedDescription:
      "Direct mutation is allowed only in the explicitly unmanaged sandbox.",
    owner: "Owner",
    file: "File",
    version: "Version",
    diagnosticsTitle: "Diagnostics",
    noDiagnostics: "No diagnostic.",
    checkValid: "Agent Spec valid",
    checkInvalid: "Agent Spec invalid",
    verificationTitle: "Final verification",
    verificationVerified: "State verified",
    verificationDrifted: "Drift detected",
    desiredStateMatch: "Desired state matches",
    planApplied: "Plan applied",
    approvalApplied: "Approval consumed",
    provenance: "Provenance",
    studioPanelTitle: "Calisto",
    studioPanelDescription:
      "This shared thread changes only the Agent Spec V2 draft.",
    studioNoThread: "No thread for this Agent.",
    studioNoThreadYet: "No thread yet.",
    studioThreadsTitle: "Studio threads",
    studioThreadsLoading: "Loading threads…",
    studioSelectThreadHint:
      "Select a thread in the sidebar or create a new one.",
    studioCreateThread: "New thread",
    studioCreateThreadSuccess: "New thread created",
    studioCreatingThread: "Creating…",
    studioFromGoalAction: "From a goal",
    studioFromGoalTitle: "Start from a goal",
    studioFromGoalDescription:
      "Creates a Studio thread with a closed_loop StudioJob bound to this goal.",
    studioFromGoalTitleLabel: "Goal title",
    studioFromGoalTitlePlaceholder: "e.g. Add a research workflow",
    studioFromGoalDescriptionLabel: "Description (optional)",
    studioFromGoalDescriptionPlaceholder:
      "Success criteria or context useful for Calisto…",
    studioFromGoalCancel: "Cancel",
    studioFromGoalConfirm: "Create StudioJob",
    studioFromGoalPending: "Creating…",
    studioFromGoalSuccess: "StudioJob created from goal",
    studioThreadLabel: "Shared thread",
    studioEmptyMessages: "Describe the changes to make to this Agent.",
    studioMessagePlaceholder:
      "Describe the behavior, Workflows, or MiniApps to change…",
    studioSend: "Send",
    studioSending: "The model is preparing a proposal…",
    studioActivityTool: "Calisto is using Agent Spec tools…",
    studioRuntimeToolResult: "{{name}} tool result",
    studioWorkflowExecution: "{{name}} Workflow execution",
    studioShowStructuredResult: "Show structured result",
    studioViewExecution: "View execution, logs, and trace",
    studioActivityCheck: "Calisto is checking the draft…",
    studioResponseTimeout:
      "The Studio response is taking too long. The thread was refreshed; you can try again.",
    studioAttach: "Attach a document",
    studioAttachmentReady: "{{name}} ready",
    studioAttachmentRejected: "{{name}} rejected",
    studioDraftValid: "Valid draft",
    studioDraftInvalid: "{{count}} diagnostic(s)",
    studioPreparePlan: "Prepare plan",
    studioPreparingPlan: "Sealing…",
    studioPlanPrepared: "Revision sealed and plan selected.",
    studioNewRevision: "Start a new revision",
    studioStreamingConnected: "Synchronized",
    studioStreamingDisconnected: "Reconnecting…",
    studioSharedHint: "Visible to all editors of this Agent.",
    studioNoAgent: "Select an Agent to open Studio.",
    studioWritePermissionRequired:
      "The write:recipes permission is required to use Studio.",
    studioError: "Studio is temporarily unavailable.",
    studioRevisionConflict:
      "The draft changed during this turn. The thread was refreshed and your message was restored; you can send it again.",
    studioNoActiveDraft:
      "This revision is no longer an editable draft. Click “Start a new revision”, then describe the change in the thread.",
    studioRevisionStatus: {
      none: "No revision",
      draft: "Draft",
      sealed: "Sealed revision",
      planned: "Planned revision",
      terminal: "Terminal revision",
    },
    studioAction: {
      prepare_plan: "Prepare plan",
      approve: "Review approval",
      apply: "Review apply",
      verify: "Review verification",
      preview: "Open preview",
      test: "Test resource",
      create_sandbox_agent: "Create a sandbox Agent and test this draft there",
      new_revision: "Start a new revision",
    },
  },
  es: {
    calistoNavigation: "Calisto",
    currentPlanTitle: "Plan actual",
    currentPlanDescription:
      "El plan a tratar ahora: progreso, siguiente acción, luego el historial de otros planes.",
    currentPlanEmpty:
      "Ningún plan seleccionado. Prepáralo desde el hilo Studio, o abre uno del historial.",
    otherPlansTitle: "Otros planes",
    otherPlansDescription:
      "Historial de planes preparados por MauriceCLI, MCP o el OS. Un clic lo convierte en el plan actual.",
    otherPlansEmpty: "Ningún otro plan — el plan actual es el único disponible.",
    persistedPlansTitle: "Planes persistidos para revisar",
    persistedPlansDescription:
      "Planes preparados por MauriceCLI, MCP o el OS. Carga el detalle exacto antes de cualquier aprobación humana.",
    persistedPlansLoading: "Cargando planes persistidos…",
    persistedPlansError: "No se pudieron cargar los planes persistidos.",
    persistedPlansEmpty:
      "No hay ningún plan preparado, aprobado o aplicado recientemente.",
    railTitle: "Plan actual",
    railDescription:
      "En development: prepara y despliega desde el hilo Studio. Staging/producción requieren aprobación humana.",
    railHintPull: "Carga primero el desired state (Pull).",
    railHintPrepare:
      "Siguiente: Preparar el plan desde el hilo Studio actual (check + plan; en development la aplicación puede continuar automáticamente).",
    railHintApprove:
      "Siguiente: Aprobar el plan (aprobación humana requerida en este entorno).",
    railHintCloseout:
      "Siguiente: Poner en marcha (apply → verify, con reparación automática si hace falta).",
    railHintApplyPersisted:
      "Siguiente: Aplicar este plan persistido. « Poner en marcha » solo vale para el plan sellado del hilo Studio.",
    railHintSuperseded:
      "Este plan fue reemplazado o caducó. Se seleccionó un plan más reciente, o prepara uno nuevo desde el hilo Studio.",
    railHintVerify: "Siguiente: Verificar el resultado runtime.",
    studioPrepareAutoAction: "Preparación automática…",
    studioPrepareAutoPending: "Preparación y puesta en marcha…",
    studioPrepareAutoStarted: "Plan preparado — closeout en curso o terminado.",
    studioCloseoutStayInChat:
      "Draft aplicado. Para seguir modificando, empieza una nueva revisión y describe el cambio.",
    studioNewRevisionReady:
      "Nuevo draft listo — describe el siguiente cambio a Calisto.",
    studioNewRevisionHint:
      "Abre un nuevo draft editable en este hilo. Luego describe el cambio en el campo de abajo.",
    studioContinueWithCalisto: "Continuar con Calisto",
    studioViewAppliedPlan: "Ver el plan aplicado",
    studioNewRevision: "Empezar una nueva revisión",
    studioNoActiveDraft:
      "Esta revisión ya no es un draft editable. Haz clic en « Empezar una nueva revisión », luego describe el cambio en el hilo.",
    railHintIdle: "Ninguna acción urgente — este plan ya está tratado o fuera de ventana.",
    railHintSelectOrCalisto:
      "Abre Calisto para preparar un plan desde un hilo Studio, o elige un plan del historial.",
    closeoutRequiresSealedRevision:
      "Poner en marcha exige un plan preparado desde el hilo Studio (revisión sellada). Para este plan, usa « Aplicar el plan ».",
    closeoutRequiresPlan:
      "Ningún plan está vinculado a la revisión Studio. Prepara primero el plan desde el hilo.",
    refreshPlans: "Actualizar planes",
    planStatusPrepared: "Pendiente de aprobación",
    planStatusApproved: "Aprobado",
    planStatusApplying: "Aplicando",
    planStatusApplied: "Aplicado",
    planStatusFailed: "Fallido",
    planStatusExpired: "Caducado",
    planStatusSuperseded: "Reemplazado",
    gitCommit: "Commit Git",
    expiresAt: "Caducidad",
    exactArtifactTitle: "Artefacto ejecutable exacto",
    exactArtifactDescription:
      "Este artefacto persistido es el que autoriza la aprobación y el que apply ejecutará sin recompilar.",
    previewRequiresSandboxTitle: "Preview no disponible en este Agente",
    previewRequiresSandboxBody:
      "El Agente actual está en modo « {{profile}} ». La preview del draft está limitada a sandbox, development e integration_test. En staging/producción usa el ciclo de aprobación, o cambia a un Agente de desarrollo.",
    previewRequiresSandboxError:
      "La preview del draft no está disponible en este Agente (modo « {{profile}} »). Está permitida en sandbox, development e integration_test.",
    previewUnknownProfile: "desconocido",
    invalidPlanId:
      "Identificador de plan inválido en la URL — parámetro ignorado. Selecciona un plan de la lista.",
    previewCreateSandboxAgent: "Crear un Agente sandbox y probar este draft allí",
    previewSwitchAgentHint:
      "O abre el selector de Agente arriba a la izquierda para cambiar a un Agente sandbox existente.",
    previewCreateSandboxTitle: "Crear un Agente sandbox",
    previewCreateSandboxDescription:
      "Se creará un Agente clasificado como sandbox. Podrás inicializar un draft allí y lanzar previews sin tocar este Agente.",
    previewCreateSandboxSeedDialogTitle:
      "Crear un Agente sandbox y probar este draft allí",
    previewCreateSandboxSeedDescription:
      "Confirma para crear el Agente sandbox, copiar este draft, abrir el chat y continuar la preview.",
    previewCreateSandboxSeedConfirm: "Confirmar",
    previewCreateSandboxSeedTitle: "Draft sandbox — {{name}}",
    previewCreateSandboxSeedSuccess:
      "Agente sandbox {{name}} listo. Draft copiado — preview en curso.",
    previewCreateSandboxContinueStarted:
      "Preview del draft reanudada en el sandbox.",
    previewCreateSandboxContinueFailed:
      "El draft se copió, pero la preview no pudo iniciarse automáticamente.",
    previewCreateSandboxNameLabel: "Nombre del Agente",
    previewCreateSandboxNamePlaceholder: "Asistente sandbox",
    previewCreateSandboxConfirm: "Crear y abrir",
    previewCreateSandboxSubmitting: "Creando…",
    previewCreateSandboxSuccess: "Agente sandbox {{name}} creado.",
    previewCreateSandboxFailed: "No se pudo crear el Agente sandbox.",
    previewCreateSandboxConflict:
      "Ya existe un Agente con ese nombre. Elige otro nombre.",
    previewCreateSandboxNameRequired: "El nombre del Agente es obligatorio.",
    studioAction: {
      create_sandbox_agent: "Crear un Agente sandbox y probar este draft allí",
    },
  },
} as const;
